var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74898 11.8184L10.3619 13.3988C10.8404 13.6884 11.4259 13.2602 11.3 12.7188L10.6074 9.74702L12.9181 7.74485C13.3399 7.37968 13.1133 6.68711 12.5592 6.64303L9.51819 6.38489L8.32822 3.57682C8.11415 3.06684 7.3838 3.06684 7.16973 3.57682L5.97977 6.3786L2.93875 6.63674C2.38469 6.68081 2.15803 7.37338 2.57987 7.73856L4.89054 9.74072L4.19797 12.7125C4.07205 13.254 4.65759 13.6821 5.13609 13.3925L7.74898 11.8184Z",
    fill: " #752991"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIconBlack);
export default __webpack_public_path__ + "static/media/starIconBlack.503b54a9b0dc73ab95abe2e0faf93283.svg";
export { ForwardRef as ReactComponent };